import DSSkeleton from '@carvana/ds-skeleton';
import cx from 'classnames';

const defaultSkeletonClassNames = 'rounded-sm mb-0';

export default function Skeleton({
  className,
  ...props
}: React.HTMLProps<HTMLDivElement>) {
  return (
    <DSSkeleton
      className={cx(defaultSkeletonClassNames, className)}
      {...props}
    />
  );
}
